/**
 * XML Utility Functions
 * Shared utilities for XML/SVG generation
 */

/**
 * Escape XML special characters in a string
 * Used by SVG and LBRN generators
 */
export function escapeXml(str: string): string {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}
